import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getMessagesContent = createAsyncThunk(
  "/messages/content",
  async () => {
    const response = await axios.get("/api/users?page=2", {});
    return response.data;
  },
);

export const messagesSlice = createSlice({
  name: "messages",
  initialState: {
    isLoading: false,
    messages: [],
  },
  reducers: {
    addNewMessage: (state, action) => {
      let { newMessageObj } = action.payload;
      state.messages = [...state.messages, newMessageObj];
    },

    deleteMessage: (state, action) => {
      let { index } = action.payload;
      state.messages.splice(index, 1);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getMessagesContent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMessagesContent.fulfilled, (state, action) => {
        state.messages = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getMessagesContent.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { addNewMessage, deleteMessage } = messagesSlice.actions;

export default messagesSlice.reducer;
